<template>
  <div>
    <div class="border-b-3 border-app-color pb-10 mb-14">
      <p class="text-15 text-grey-675">Upcoming</p>
      <p class="text-24 font-extrabold leading-small">Events</p>
    </div>

    <div class="">
      <div class="flex overflow-x-auto -m-1">
        <UpcomingEvent v-for="event in events" :key="event.id" :event="event" @click="getWeek(event)" />
      </div>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent } from 'vue'
import { useStore } from 'vuex'

import UpcomingEvent from '@/components/week-planner/UpcomingEvent'

export default defineComponent({
  components: { UpcomingEvent },

  props: {
    startDate: String
  },

  emits: ['getWeek'],

  setup (props, { emit }) {
    const { state } = useStore()

    const events = computed(() => state.planner.upcoming.events)
    const count = computed(() => state.planner.upcoming.count)

    function getWeek (event) {
      emit('getWeek', new Date(event.showAt))
    }

    return {
      count,
      events,
      getWeek
    }
  }
})
</script>
